/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Summary_Content_Past_4Inputs */



/**
* | output |
* | --- |
* | "wrote things up" |
*
* @param {Chat_Summary_Content_Past_4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_summary_content_past_4 = /** @type {((inputs?: Chat_Summary_Content_Past_4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Summary_Content_Past_4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("etwas ausgeschrieben")
	return /** @type {LocalizedString} */ ("wrote things up")
});